import { cva, VariantProps } from 'class-variance-authority'
import { cn } from '~/lib/utils'
import Play from './icon/play'
import { useId } from 'react'

type PlayButtonProps = {
  colour: VariantProps<typeof playButtonVariants>['colour']
  data: {
    duration: number
    ariaLabel: string
    label: string | null | undefined
  }
  disabled?: boolean
}

const playButtonVariants = cva(
  'unstyled-link gap-2xs py-2xs pl-2xs pr-xs group relative flex items-center shadow-none',
  {
    variants: {
      colour: {
        'Ink Blue': 'bg-blue-d text-white',
        'Mid Blue': 'bg-blue-m text-white',
        Chartreuse: 'bg-char text-blue-d',
        White: 'bg-white text-blue-d!'
      }
    },
    defaultVariants: {
      colour: 'Ink Blue'
    }
  }
)

const PlayButton = ({ colour, ...props }: PlayButtonProps) => {
  const id = useId()

  return (
    <button
      {...(props?.data?.ariaLabel !== ''
        ? { 'aria-label': props?.data?.ariaLabel }
        : {})}
      className={cn(playButtonVariants({ colour }), 'cursor-pointer')}
    >
      <Play fill={''} width={'1.25rem'} height={'1.25rem'} title={''} id={id} />
      <div className='tag flex grow flex-col justify-between'>
        {props?.data?.label}
        {props?.data?.duration > 0 && (
          <span className='gap-2xs text-tag-sm flex font-normal uppercase'>
            {props?.data?.duration}{' '}
            {props?.data?.duration === 1 ? 'Min' : 'Mins'}
          </span>
        )}
      </div>
    </button>
  )
}

export default PlayButton
